/**
 * Nutrient row component - extracted to avoid hook calls in map
 */
import * as React from 'react';
import styled from '@emotion/styled';
import { useTrans } from '../../../Store/System/LocalizationStore';
import { Theme } from '../../../Theme/Theme';
import { Nutrient } from '../../../Model/Diet/Ingredient/Nutrient';

const TableRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid ${Theme.Colors.lighterGrey};

  &:last-child {
    border-bottom: none;
  }
`;

const TableLabel = styled.span`
  font-size: 0.95rem;
  color: ${Theme.Colors.textColor};
`;

const TableValue = styled.span`
  font-size: 0.95rem;
  color: ${Theme.Colors.charcoal};
  text-align: right;
`;

type NutrientRowProps = {
  nutrientKey: string;
  nutrient: Nutrient;
};

export const NutrientRow: React.FC<NutrientRowProps> = ({ nutrientKey, nutrient }) => {
  const { t } = useTrans();

  return (
    <TableRow>
      <TableLabel>{t(`explore.dietTab.recipeScreen.nutritionInformation.${nutrientKey}`)}</TableLabel>
      <TableValue>
        {(nutrient.amount || 0).toFixed(1)} {nutrient.unit || ''}
      </TableValue>
    </TableRow>
  );
};
